const prefix = 'user';

export const getAllUsers = `${prefix}/admin`;

export const getUserLogsSummary = (userId: string) => `/admin/users/${userId}/logs`;

export const getBlockedUsers = `/user-restriction`;

export const blockUser = (userId: string) => `/user-restriction/${userId}`;
